import { z } from 'zod';

/** Роли 001 — табель: бригадир и кадры. Действия маршрутов 001 есть только у них. */
export const ROLES = ['brigadier', 'hr'] as const;
export const Role = z.enum(ROLES);
export type Role = z.infer<typeof Role>;

/**
 * Шесть ролей на объект (002, «Права ролей»; 004, research R18); роли 001 — их часть. Тот же список, что роли
 * назначений в базе (`api/src/db/schema/org.ts`, `ROLES`), — проверяет тест `api/tests/integration/auth-roles.test.ts`.
 */
export const APP_ROLES = ['brigadier', 'hr', 'rules_admin', 'approver', 'auditor', 'sysadmin'] as const;
export const AppRole = z.enum(APP_ROLES);
export type AppRole = z.infer<typeof AppRole>;

export const LoginRequest = z.object({
  login: z.string().min(1).max(50),
  password: z.string().min(1).max(200),
});
export type LoginRequest = z.infer<typeof LoginRequest>;

export const UserInfo = z.object({
  fullName: z.string(),
  position: z.string(),
  /** Роли из действующих сегодня назначений (`role_assignments`), порядок — `APP_ROLES`; не поле `users.roles` 001. */
  roles: z.array(AppRole),
});
export type UserInfo = z.infer<typeof UserInfo>;

export const MeResponse = z.object({
  user: UserInfo,
  /** 010: явно выданные права новых справочников, не роли табельного модуля. */
  directoryCapabilities: z.array(z.string()).optional(),
  object: z.object({ id: z.string(), name: z.string(), tzOffset: z.string() }),
  lastPassAt: z.string().nullable(),
  /** Данные СКУД устарели: в рабочее время объекта новых проходов нет дольше порога объекта (003, R14, FR-039). */
  dataStale: z.boolean().optional(),
  /** Бригады роли «бригадир» на объекте (окно «Новый табель», 003 T080); у других ролей поля нет. */
  brigades: z.array(z.object({ id: z.number().int(), name: z.string() })).optional(),
  /**
   * Объекты пользователя с действующими сегодня назначениями (007, переключатель объекта): порядок — таблица
   * `objects`, роли — порядок `APP_ROLES`. Сервер присылает всегда; в схеме необязательно — ответы до 007.
   */
  objects: z.array(z.object({ id: z.string(), name: z.string(), roles: z.array(AppRole) })).optional(),
});
export type MeResponse = z.infer<typeof MeResponse>;
